import { render } from "./TabsComponent.vue?vue&type=template&id=243f7673"
import script from "./TabsComponent.vue?vue&type=script&lang=js"
export * from "./TabsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__